import {
    ApiBaseService,
    type PaginatedFetch,
    type PaginatedFetchOptions,
} from "./ApiBaseService";
import type {
    DataSource,
    DataSourceTemplate,
    DataSourceItem,
} from "~/models/DataSource";
import type { ApiResponse } from "~/types/ApiResponse";

export type CreateOrUpdateDataSource = Partial<
    Omit<DataSource, "id" | "created_at" | "updated_at" | "deleted_at">
>;

export default class DataSourceService extends ApiBaseService {
    public list(
        options?: Partial<PaginatedFetchOptions>,
    ): PaginatedFetch<DataSource> {
        return this.paginate<DataSource>(
            this.route("api.data_sources.index", "/data_sources"),
            options as PaginatedFetchOptions,
        );
    }

    public store(
        data?: CreateOrUpdateDataSource,
    ): Promise<ApiResponse<DataSource>> {
        return this.request(
            this.route("api.data_sources.store", "/data_sources"),
            {
                method: "POST",
                body: data,
            },
        );
    }

    public find(id: string): Promise<ApiResponse<DataSource>> {
        return this.request(
            this.route("api.data_sources.show", "/data_sources/{id}", {
                id,
            }),
        );
    }

    public listItems(id: string): Promise<ApiResponse<DataSourceItem[]>> {
        return this.request(
            this.route("api.data_sources.items", "/data_sources/{id}/items", {
                id,
            }),
        );
    }

    public update(
        id: string,
        data: CreateOrUpdateDataSource,
    ): Promise<ApiResponse<DataSource>> {
        return this.request(
            this.route("api.data_sources.store", "/data_sources/{id}", {
                id,
            }),
            {
                method: "PATCH",
                body: data,
            },
        );
    }

    public delete(id: string): Promise<null> {
        return this.request(
            this.route("api.data_sources.destroy", "/data_sources/{id}", {
                id,
            }),
            {
                method: "DELETE",
            },
        );
    }

    public listTemplates(): Promise<ApiResponse<DataSourceTemplate[]>> {
        return this.request(
            this.route("api.data_sources.templates", "/data_source_templates"),
        );
    }
}
